import ApiEndpoint, { ApiResponse } from 'network/ApiEndpoint'
import { mapEventResponse } from './mapEventResponse'

export const getEventGamesFromGroup = async ({
  channelSlug,
  eventSlug,
  selectedGroup,
  currentPage,
  perPage
}: {
  channelSlug: string
  eventSlug: string
  selectedGroup: string
  currentPage: number
  perPage: number
}) => {
  try {
    const resultResponse: ApiResponse = await ApiEndpoint.call({
      path: `events/event/${eventSlug}/group/${selectedGroup}/games`,
      params: {
        company: channelSlug,
        page: currentPage,
        per_page: perPage
      }
    })
    const responseData = await resultResponse

    const map = responseData.data.games
      ? mapEventResponse(responseData.data.games, false)
      : []

    return { data: map, totalCount: responseData.totalCount }
  } catch (e: any) {
    // @ts-ignore
    throw new Error(e.message)
  }
}
